import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const serviceData = [
  {
    id: 1,
    number: '01',
    title: '一般貨物運送',
    subtitle: 'General Cargo',
    catch: '1t・2t・4tで幅広い荷物に対応\n安全・丁寧・確実な配送をお約束',
    description:
      '1tバン・2t箱車・2tゲート・4t平・4tウィング(ゲート付き等)にて、幅広い荷物に対応をしております。もちろんスポット便も対応が可能です。',
    image:
      'https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/8f6cb16ebc193665160f8524d2b6b456.jpeg',
    link: '#cargo',
    color: 'bg-teal-500',
  },
];

export default function Service() {
  const titleAnim = useScrollAnimation();
  const serviceAnim = useScrollAnimation({ rootMargin: '0px 0px -80px 0px' });
  const ctaAnim = useScrollAnimation({ rootMargin: '0px 0px -60px 0px' });
  const imgLeftAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });
  const imgRightAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  return (
    <section id="service" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={titleAnim.ref}
          className={titleAnim.isVisible ? 'anim-fade-up' : 'anim-hidden'}
        >
          <div className="mb-8 md:mb-12">
            <div className="flex items-center gap-3 mb-3 md:mb-4">
              <img
                src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/758ef2cf37f252b690d6ec189d9cae34.png"
                alt=""
                className="h-6 md:h-8"
              />
              <h2 className="text-3xl md:text-5xl font-black text-gray-900">
                事業<span className="text-teal-500">内容</span>
              </h2>
            </div>
            <p className="text-xs md:text-sm text-gray-500 tracking-widest">
              Business
            </p>
          </div>
        </div>

        <div className="space-y-10 md:space-y-16">
          {serviceData.map((service, index) => (
            <div
              key={service.id}
              ref={serviceAnim.ref}
              className={`flex flex-col ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              } gap-6 md:gap-8 items-center ${serviceAnim.isVisible ? 'anim-fade-up anim-delay-200' : 'anim-hidden'}`}
            >
              {/* Text block */}
              <div className="w-full md:flex-1 order-2 md:order-none">
                <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
                  <span
                    className={`text-3xl md:text-5xl font-black ${
                      service.color.replace('bg-', 'text-')
                    } opacity-20`}
                  >
                    {service.number}
                  </span>
                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1 md:mb-2">
                      {service.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-500 font-medium mb-3 md:mb-4">
                      {service.subtitle}
                    </p>
                  </div>
                </div>

                <p className="text-base md:text-lg font-bold text-gray-900 mb-3 md:mb-4 whitespace-pre-line">
                  {service.catch}
                </p>

                <p className="text-xs md:text-sm text-gray-600 leading-relaxed mb-4 md:mb-6">
                  {service.description}
                </p>
              </div>

              {/* Image block */}
              <div className="w-full md:flex-1 order-1 md:order-none">
                <div className="relative w-full aspect-[16/10] md:aspect-[4/3] rounded-lg overflow-hidden shadow-lg">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom call-to-action section */}
        <div
          ref={ctaAnim.ref}
          className={ctaAnim.isVisible ? 'anim-scale-in anim-delay-100' : 'anim-hidden'}
        >
          <div className="mt-10 md:mt-16 bg-gradient-to-b from-gray-50 to-white rounded-xl md:rounded-2xl p-6 md:p-12">
            <h3 className="text-xl sm:text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6 leading-relaxed">
              お客様がコア業務に<span className="text-teal-500">集中</span>できる
              <br className="hidden sm:block" />
              環境を届けます
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8 mt-6 md:mt-8">
              <div
                ref={imgLeftAnim.ref}
                className={imgLeftAnim.isVisible ? 'anim-fade-left anim-delay-300' : 'anim-hidden'}
              >
                <div className="relative w-full aspect-[16/10] md:aspect-[4/3] rounded-lg overflow-hidden shadow-lg">
                  <img
                    src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/3d0cc3b8a10b0d8d0480dddc0cf84802.jpeg"
                    alt="物流作業"
                    className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
                  />
                </div>
              </div>

              <div
                ref={imgRightAnim.ref}
                className={imgRightAnim.isVisible ? 'anim-fade-right anim-delay-400' : 'anim-hidden'}
              >
                <div className="relative w-full aspect-[16/10] md:aspect-[4/3] rounded-lg overflow-hidden shadow-lg">
                  <img
                    src="https://storage.readdy-site.link/project_files/1dabbddb-19db-4cfd-9ba9-9c36e919f8d4/21eb4024-cce3-446f-836b-c9a315f17892_unnamed.jpg?v=8e69c7adbe3c01f8dc885eb05fc4481d"
                    alt="倉庫作業"
                    className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
